import axios from 'axios';
import constants from '../constants';

function log(memberId, designId, details) {
  if (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('test.mhmfun.com') > -1) return;
  axios.post(`${constants.urlPrefix}/api/frontend/log`, {
    agent: window.navigator.userAgent,
    memberId,
    designId,
    details
  });
}

export default {
  log
};
